import React, { FunctionComponent } from "react";

import { AnyOrderItem } from "../../../../../stores/slices/cartSlice";
import { AdditionalItem } from "./AdditionalItem";
import { MandatoryItem } from "./MandatoryLineItem";

export const LineItems: FunctionComponent<{
  isOrder: boolean;
  orderItem: AnyOrderItem;
}> = ({ isOrder, orderItem }) => {
  const optionalItems = [
    ...orderItem.includedOptionalLineItemList,
    ...orderItem.additionalOptionalLineItemList,
  ];

  if (!(orderItem.mandatoryLineItemList.length + optionalItems.length)) {
    return null;
  }
  return (
    <div className="space-y-2 text-xs">
      {orderItem.mandatoryLineItemList.map((item) => (
        <MandatoryItem item={item} key={item.lineItemId} />
      ))}
      {optionalItems.map((item) => (
        <AdditionalItem
          isOrder={isOrder}
          key={item.lineItemId}
          lineItem={item}
          orderItem={orderItem}
        />
      ))}
    </div>
  );
};
